import { render, staticRenderFns } from "./AnswerBlocksLoop.vue?vue&type=template&id=46506569&scoped=true&lang=pug"
import script from "./AnswerBlocksLoop.vue?vue&type=script&lang=ts"
export * from "./AnswerBlocksLoop.vue?vue&type=script&lang=ts"
import style0 from "./AnswerBlocksLoop.vue?vue&type=style&index=0&id=46506569&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46506569",
  null
  
)

/* custom blocks */
import block0 from "./AnswerBlocksLoop.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FQuestionnaire%2Fcomponents%2FAnswerBlocks%2FAnswerBlocksLoop.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports